"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.cssAnchorName = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _phrase = _interopRequireDefault(require("@insided/deprecated-libs/translationsUtils/phrase"));

var _csrf = require("@insided/shared/utils/csrf");

var _classnames = _interopRequireDefault(require("classnames"));

var _axios = _interopRequireDefault(require("axios"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var cssAnchorName = 'disconnect-sso';
exports.cssAnchorName = cssAnchorName;
var PROVIDER_CONFIG = {
  facebook: {
    connectButtonClass: 'btn btn--connect-profile btn--facebook',
    disconnectButtonClass: 'decouple',
    connectedPhrase: 'member.profile.connected_facebook',
    disconnectPhrase: 'member.profile.disconnect_facebook',
    connectPhrase: 'member.profile.connect_facebook',
    disconnectRoute: '/settings/disconnectFacebook'
  },
  linkedin: {
    connectButtonClass: 'btn btn--connect-profile btn--linkedin',
    disconnectButtonClass: 'decouple',
    connectedPhrase: 'member.profile.connected_linkedin',
    disconnectPhrase: 'member.profile.disconnect_linkedin',
    connectPhrase: 'member.profile.connect_linkedin',
    disconnectRoute: '/settings/disconnectLinkedin'
  }
};

var DisconnectSso = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(DisconnectSso, _Component);

  var _super = _createSuper(DisconnectSso);

  function DisconnectSso() {
    var _this;

    (0, _classCallCheck2.default)(this, DisconnectSso);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      isConnected: _this.props.isConnected,
      isLoading: false
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleDisconnect", /*#__PURE__*/function () {
      var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(e) {
        var url;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                e.preventDefault();
                e.stopPropagation();

                if (!_this.state.isLoading) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt("return");

              case 4:
                url = (0, _absoluteUrlRuntime.resolveUrl)(PROVIDER_CONFIG[_this.props.provider].disconnectRoute);

                _this.setState({
                  isLoading: true
                });

                _context.prev = 6;
                _context.next = 9;
                return _axios.default.post(url, new URLSearchParams((0, _csrf.withCsrf)()));

              case 9:
                _this.setState({
                  isConnected: false,
                  isLoading: false
                });

                _context.next = 15;
                break;

              case 12:
                _context.prev = 12;
                _context.t0 = _context["catch"](6);

                _this.setState({
                  isLoading: false
                });

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[6, 12]]);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    return _this;
  }

  (0, _createClass2.default)(DisconnectSso, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          provider = _this$props.provider,
          canDisconnect = _this$props.canDisconnect,
          connectUrl = _this$props.connectUrl;
      var _this$state = this.state,
          isConnected = _this$state.isConnected,
          isLoading = _this$state.isLoading;
      var cfg = PROVIDER_CONFIG[provider];
      var disconnectHref = (0, _absoluteUrlRuntime.resolveUrl)(cfg.disconnectRoute);
      return (0, _preact.h)("span", null, isConnected && (0, _preact.h)("span", null, (0, _preact.h)(_phrase.default, {
        m: "Common",
        p: cfg.connectedPhrase,
        renderAsText: true
      })), isConnected && canDisconnect && (0, _preact.h)("a", {
        href: (0, _absoluteUrlRuntime.resolveUrl)(disconnectHref),
        class: (0, _classnames.default)(cfg.disconnectButtonClass, {
          'is-loading': isLoading
        }),
        onClick: this.handleDisconnect
      }, (0, _preact.h)(_phrase.default, {
        m: "Common",
        p: cfg.disconnectPhrase,
        renderAsText: true
      })), (0, _preact.h)("a", {
        href: (0, _absoluteUrlRuntime.resolveUrl)(connectUrl),
        class: (0, _classnames.default)(cfg.connectButtonClass, {
          'is-hidden': isConnected
        })
      }, (0, _preact.h)(_phrase.default, {
        m: "Common",
        p: cfg.connectPhrase,
        renderAsText: true
      })));
    }
  }]);
  return DisconnectSso;
}(_preact.Component);

exports.default = DisconnectSso;